import { render, staticRenderFns } from "./td-secondary.vue?vue&type=template&id=73819643&scoped=true&"
import script from "./td-secondary.vue?vue&type=script&lang=js&"
export * from "./td-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73819643",
  null
  
)

export default component.exports